export const locale = {
    lang: 'en',
    data: {
        LOGIN: {
            TITLES: {
                LOGIN: 'Log In',
                WELCOME_BACK: 'Welcome back! Please enter your details.',
                USERNAME: 'Email',
                PASSWORD: 'Password',
                FORGOT_PASSWORD: 'Forgot password?',
                AGREE_TERMS: 'By logging in you agree to the',
                TERMS_CONDITIONS: 'Terms & Conditions',
                AND: 'and',
                PRIVACY_POLICY: 'Privacy Policy'
            },
            VALIDATION: {
                PASSWORD_REQUIRED_VALIDATION: 'Password is required',
                USERNAME_VALIDATION: 'Please enter a valid username',
                USERNAME_REQUIRED_VALIDATION: 'Email is required'
            },
            ERRORS: {
                SERVER: {
                    WRONG_CREDENTIALS: 'Email or password is wrong'
                }
            }
        }
    }
};